// Palette

export default {
  root: {}
};
